import { render, staticRenderFns } from "./ButtonRemoveItem.vue?vue&type=template&id=16063b14&scoped=true"
import script from "./ButtonRemoveItem.vue?vue&type=script&lang=js"
export * from "./ButtonRemoveItem.vue?vue&type=script&lang=js"
import style0 from "./ButtonRemoveItem.vue?vue&type=style&index=0&id=16063b14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16063b14",
  null
  
)

export default component.exports